module.exports = __webpack_public_path__ + "img/EffectOne.90983b03.png";